/* ATHLETIX mobile enhancements. Keeps Horizon's native drawer and accordion. */
function mountAthletixMobileExtras() {
  document.querySelectorAll('.header__drawer template[data-athletix-mobile-template]').forEach((template) => {
    const wrapper = template.closest('.header__drawer');
    const navigation = wrapper?.querySelector('.menu-drawer__navigation');
    if (!navigation || navigation.querySelector('.athletix-mobile-top')) return;
    const fragment = template.content.cloneNode(true);
    const top = fragment.querySelector('.athletix-mobile-top');
    const bottom = fragment.querySelector('.athletix-mobile-bottom');
    if (top) navigation.prepend(top);
    if (bottom) navigation.append(bottom);
  });
}
mountAthletixMobileExtras();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountAthletixMobileExtras, { once: true });
}
document.addEventListener('shopify:section:load', mountAthletixMobileExtras);
